<template>
  <vuestic-sidebar :hidden="isOpen">

    <!-- 会員向けメニュー -->
    <template slot="menu" v-if="user.admin_flag==0">
      <sidebar-link 
        :to="{ name: 'info' }">
        <span slot="title">
          <span
            class="sidebar-menu-item-icon vuestic-icon vuestic-icon-comments"></span>
          <span>ご挨拶</span>
        </span>
      </sidebar-link>
      <sidebar-link :to="{ name: 'candi' }" v-if="candiFlag">
        <span slot="title">
          <span
            class="sidebar-menu-item-icon ion ion-ios-hand"></span>
          <span>立候補する</span>
        </span>
      </sidebar-link>
      <sidebar-link :to="{ name: 'vote-list' }" v-if="voteFlag">
        <span slot="title">
          <span
            class="sidebar-menu-item-icon ion ion-ios-document"></span>
          <span>投票する</span>
        </span>
      </sidebar-link>
      <sidebar-link
        :to="{ name: 'update', params: { id: 111 }}">
        <span slot="title">
          <span
            class="sidebar-menu-item-icon ion ion-ios-document"></span>
          <span>会員情報変更</span>
        </span>
      </sidebar-link>

      <sidebar-link
          :to="{ name: 'login' }">
        <span slot="title">
          <span
            class="sidebar-menu-item-icon vuestic-icon vuestic-icon-auth"></span>
          <span slot="title">
            <span>ログアウト</span>
          </span>
        </span>
      </sidebar-link>
    </template>



    <!-- 管理者向けメニュー -->
    <template slot="menu" v-if="user.admin_flag==1">
      <sidebar-link-group>
        <span slot="title">
          <span
            class="sidebar-menu-item-icon ion ion-ios-person"></span>
          <span>会員情報</span>
        </span>
        <sidebar-link
          :to="{ name: 'user-list' }">
          <span slot="title">
            <span>会員一覧</span>
          </span>
        </sidebar-link>
        <sidebar-link
          :to="{ name: 'user-insert' }">
          <span slot="title">
            <span>会員新規登録</span>
          </span>
        </sidebar-link>
        <sidebar-link
          :to="{ name: 'user-upload' }">
          <span slot="title">
            <span>一括アップロード</span>
          </span>
        </sidebar-link>
      </sidebar-link-group>
      <sidebar-link-group>
        <span slot="title">
          <span
            class="sidebar-menu-item-icon ion ion-ios-mail"></span>
          <span>メール</span>
        </span>
        <sidebar-link :to="{ name: 'mail-send'}">
          <span slot="title">
            <span>一斉メール</span>
          </span>
        </sidebar-link>
        <sidebar-link :to="{ name: 'mail-history'}">
          <span slot="title">
            <span>送信履歴</span>
          </span>
        </sidebar-link>
      </sidebar-link-group>
      <sidebar-link-group>
        <span slot="title">
          <span
            class="sidebar-menu-item-icon ion ion-ios-hand"></span>
          <span>選挙管理</span>
        </span>
        <sidebar-link :to="{ name: 'election-update'}">
          <span slot="title">
            <span>選挙情報入力</span>
          </span>
        </sidebar-link>
        <sidebar-link :to="{ name: 'election-vote-list'}">
          <span slot="title">
            <span>選挙立候補者一覧</span>
          </span>
        </sidebar-link>
        <sidebar-link :to="{ name: 'election-analytics'}">
          <span slot="title">
            <span>得票状況</span>
          </span>
        </sidebar-link>
      </sidebar-link-group>
      <sidebar-link
        :to="{ name: 'info-update' }">
        <span slot="title">
          <span
            class="sidebar-menu-item-icon ion ion-ios-paper"></span>
          <span>あいさつ文編集</span>
        </span>
      </sidebar-link>

      <sidebar-link :to="{ name: 'login' }">
        <span slot="title">
          <span
            class="sidebar-menu-item-icon vuestic-icon vuestic-icon-auth"></span>
          <span slot="title">
            <span>ログアウト</span>
          </span>
        </span>
      </sidebar-link>
    </template>
  </vuestic-sidebar>
</template>

<script>

import VuesticSidebar
  from '../../../vuestic-theme/vuestic-components/vuestic-sidebar/VuesticSidebar'
import SidebarLink from './components/SidebarLink'
import SidebarLinkGroup from './components/SidebarLinkGroup'

export default {
  name: 'app-sidebar',
  components: {
    VuesticSidebar,
    SidebarLink,
    SidebarLinkGroup
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  data () {
    var user = this.$jwt.decode()
    var candiFlag = false
    var voteFlag = false
    var nowDate = new Date()
    nowDate = nowDate.getFullYear() + '-' + ('0' + (nowDate.getMonth() + 1)).slice(-2) + '-' + ('0' + (nowDate.getDate())).slice(-2)
    if (user.election.candiStart <= nowDate && user.election.candiEnd >= nowDate) {
      candiFlag = true
    }
    if (user.election.voteStart <= nowDate && user.election.voteEnd >= nowDate) {
      voteFlag = true
    }
    return {
      user: user,
      candiFlag: candiFlag,
      voteFlag: voteFlag,
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/admin/app-sidebar/AppSidebar.vue